function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M274.707 817.098C291.38 817.86 306.725 825.129 324.289 826.994C442.531 839.571 562.385 839.571 680.623 826.994C736.182 821.101 790.283 809.875 846.235 807.238C903.651 804.507 963.136 809.162 1018.45 794.087C1084.55 776.058 1132.41 728.857 1135.09 679.025C1137.64 631.507 1103.27 587.419 1084.82 541.724C1062.99 487.503 1063.58 429.231 1086.51 375.292C1109.55 321.118 1155.02 269.511 1150.75 213.054C1144.77 134.046 1022.52 70.3657 913.441 89.3937C856.308 99.348 808.379 127.241 751.891 138.867C660.141 157.775 561.563 131.405 466.568 138.867C385.879 145.344 311.562 176.609 257.578 219.322C203.595 262.034 206.554 310.871 185.5 366C166.93 414.682 120.211 470.701 85.3095 514.711C59.7403 546.932 20.5332 574.84 9.07625 610.896C-4.35315 653.143 -44.2053 802.686 274.707 817.098Z",
  fill: "url(#paint0_linear_0_1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M595.987 142.708V169.008C595.987 170.37 597.143 171.473 598.569 171.473H598.569C599.995 171.473 601.151 170.37 601.151 169.008V142.708C601.151 141.346 599.995 140.243 598.569 140.243H598.569C597.143 140.243 595.987 141.346 595.987 142.708Z",
  fill: "#EE4B68"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M598.568 176.405V285.713",
  stroke: "url(#paint1_linear_0_1)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "2 8 2 8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M623.531 142.708V169.008C623.531 170.37 624.687 171.473 626.113 171.473H626.113C627.539 171.473 628.695 170.37 628.695 169.008V142.708C628.695 141.346 627.539 140.243 626.113 140.243H626.113C624.687 140.243 623.531 141.346 623.531 142.708Z",
  fill: "#3B82FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M571.025 171.473C569.599 171.473 568.444 170.371 568.444 169.008V142.708C568.444 141.347 569.599 140.243 571.025 140.243C572.452 140.243 573.607 141.347 573.607 142.708V169.008C573.607 170.371 572.452 171.473 571.025 171.473Z",
  fill: "#3B82FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M571.256 179.452V235.744C571.256 241.296 566.572 245.81 560.758 245.863L241.326 248.73C235.512 248.782 230.828 253.219 230.828 258.77C230.828 318.685 230.828 561.422 230.828 561.422",
  stroke: "url(#paint2_linear_0_1)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M622.916 179.452V235.744C622.916 241.296 627.6 245.81 633.414 245.863L952.846 248.73C958.66 248.782 963.344 253.219 963.344 258.77C963.344 318.685 963.344 561.422 963.344 561.422",
  stroke: "url(#paint3_linear_0_1)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M648.391 58.8093C650.924 58.8093 652.976 56.8491 652.976 54.4311C652.976 52.0131 650.924 50.0529 648.391 50.0529C645.859 50.0529 643.806 52.0131 643.806 54.4311C643.806 56.8491 645.859 58.8093 648.391 58.8093Z",
  fill: "#3B82FF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M584.2 42.7563C586.732 42.7563 588.785 40.7962 588.785 38.3782C588.785 35.9602 586.732 34 584.2 34C581.668 34 579.615 35.9602 579.615 38.3782C579.615 40.7962 581.668 42.7563 584.2 42.7563Z",
  fill: "#3B82FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M668.261 117.185C669.949 117.185 671.317 115.878 671.317 114.266C671.317 112.654 669.949 111.348 668.261 111.348C666.572 111.348 665.204 112.654 665.204 114.266C665.204 115.878 666.572 117.185 668.261 117.185Z",
  fill: "#3B82FF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M584.197 201.83C585.886 201.83 587.254 200.523 587.254 198.911C587.254 197.299 585.886 195.992 584.197 195.992C582.509 195.992 581.141 197.299 581.141 198.911C581.141 200.523 582.509 201.83 584.197 201.83Z",
  fill: "#3B82FF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M677.434 73.4027C679.122 73.4027 680.49 72.0959 680.49 70.4839C680.49 68.872 679.122 67.5652 677.434 67.5652C675.745 67.5652 674.377 68.872 674.377 70.4839C674.377 72.0959 675.745 73.4027 677.434 73.4027Z",
  fill: "#3B82FF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M520.006 83.6185C521.694 83.6185 523.063 82.3118 523.063 80.6998C523.063 79.0878 521.694 77.781 520.006 77.781C518.318 77.781 516.949 79.0878 516.949 80.6998C516.949 82.3118 518.318 83.6185 520.006 83.6185Z",
  fill: "#3B82FF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M669.307 730.734H525.179L530.064 669.616H664.42L669.307 730.734Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M669.306 730.734H525.177L530.063 669.616H664.419L669.306 730.734Z",
  fill: "#DFEAF8"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_0_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M307.765 625.395V678.287C307.765 682.027 309.308 685.615 312.057 688.26C314.806 690.904 318.534 692.39 322.422 692.39H873.283C881.378 692.39 887.94 686.075 887.94 678.287V625.395H307.765Z",
  fill: "#ABADBE"
})));

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M679.311 723.094H519.168V736.464H679.311V723.094Z",
  fill: "#DFEAF8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M872.884 281.901H323.598C315.527 281.901 308.983 288.122 308.983 295.796V609.229C308.983 611.991 311.222 614.229 313.983 614.229H882.499C885.26 614.229 887.499 611.991 887.499 609.229V295.796C887.499 292.11 885.959 288.576 883.219 285.971C880.478 283.364 876.76 281.901 872.884 281.901Z",
  fill: "#C4DBF9"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M308.983 614.228V667.002C308.983 670.734 310.523 674.314 313.265 676.953C316.005 679.593 319.722 681.075 323.598 681.075H872.884C880.956 681.075 887.499 674.775 887.499 667.002V614.228H308.983Z",
  fill: "#DFEAF8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M873.398 280H324.602C316.538 280 310 286.215 310 293.881V606.946C310 609.737 312.37 612 315.294 612H882.706C885.63 612 888 609.737 888 606.946V293.881C888 290.199 886.462 286.669 883.724 284.066C880.984 281.462 877.271 280 873.398 280Z",
  fill: "#C6D7EE"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_0_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M875.606 293H322V609.073H875.606V293Z",
  fill: "white"
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M511.748 312C510.781 312.003 510 313.121 510 314.5C510 315.879 510.781 316.997 511.748 317H558.252C559.217 316.997 560 315.879 560 314.5C560 313.121 559.217 312.003 558.252 312H511.748Z",
  fill: "#CBD5E6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M737.469 312C736.656 312.003 736 313.121 736 314.5C736 315.879 736.656 316.997 737.469 317H776.531C777.342 316.997 778 315.879 778 314.5C778 313.121 777.342 312.003 776.531 312H737.469Z",
  fill: "#CBD5E6"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M875 329H322V609H875V329Z",
  fill: "#F5F5F5"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.224 379C433.995 379.001 433 380.016 433 381.264C433 382.514 433.995 383.527 435.224 383.529H494.375C495.604 383.527 496.599 382.514 496.599 381.264C496.599 380.016 495.604 379.001 494.375 379H435.224Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.408 388.797C433.629 388.8 433 389.815 433 391.067C433 392.32 433.629 393.335 434.408 393.338H471.862C472.639 393.335 473.27 392.32 473.27 391.067C473.27 389.815 472.639 388.8 471.862 388.797H434.408Z",
  fill: "#466089"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.224 358C433.995 358.001 433 359.016 433 360.264C433 361.514 433.995 362.527 435.224 362.529H494.375C495.604 362.527 496.599 361.514 496.599 360.264C496.599 359.016 495.604 358.001 494.375 358H435.224Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.408 367.797C433.629 367.8 433 368.815 433 370.067C433 371.32 433.629 372.335 434.408 372.338H471.862C472.639 372.335 473.27 371.32 473.27 370.067C473.27 368.815 472.639 367.8 471.862 367.797H434.408Z",
  fill: "#466089"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.224 400C433.995 400.001 433 401.016 433 402.264C433 403.514 433.995 404.527 435.224 404.529H494.375C495.604 404.527 496.599 403.514 496.599 402.264C496.599 401.016 495.604 400.001 494.375 400H435.224Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.408 409.797C433.629 409.8 433 410.815 433 412.067C433 413.32 433.629 414.335 434.408 414.338H471.862C472.639 414.335 473.27 413.32 473.27 412.067C473.27 410.815 472.639 409.8 471.862 409.797H434.408Z",
  fill: "#466089"
}));

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536 355L777.822 355.047L778 399L536.178 398.953L536 355Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M559.768 374C563.357 374 566.268 371.09 566.268 367.5C566.268 363.91 563.357 361 559.768 361C556.178 361 553.268 363.91 553.268 367.5C553.268 371.09 556.178 374 559.768 374Z",
  fill: "#F24390"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536 407L776.823 407.047L777 451L536.177 450.953L536 407Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M585.539 416C581.925 416.001 579 417.016 579 418.264C579 419.514 581.925 420.527 585.539 420.529H759.461C763.075 420.527 766 419.514 766 418.264C766 417.016 763.075 416.001 759.461 416H585.539Z",
  fill: "#CBD5E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583.14 425.797C580.85 425.8 579 426.815 579 428.067C579 429.32 580.85 430.335 583.14 430.338H693.265C695.551 430.335 697.405 429.32 697.405 428.067C697.405 426.815 695.551 425.8 693.265 425.797H583.14Z",
  fill: "#CBD5E6"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M560.5 423C564.09 423 567 420.09 567 416.5C567 412.91 564.09 410 560.5 410C556.91 410 554 412.91 554 416.5C554 420.09 556.91 423 560.5 423Z",
  fill: "#5B43F2"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536 461L776.823 461.047L777 505L536.177 504.953L536 461Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M559.768 479C563.357 479 566.268 476.09 566.268 472.5C566.268 468.91 563.357 466 559.768 466C556.178 466 553.268 468.91 553.268 472.5C553.268 476.09 556.178 479 559.768 479Z",
  fill: "#988E8E"
});

var _ref35 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M584.539 469C580.925 469.001 578 470.016 578 471.264C578 472.514 580.925 473.527 584.539 473.529H758.461C762.075 473.527 765 472.514 765 471.264C765 470.016 762.075 469.001 758.461 469H584.539Z",
  fill: "#CBD5E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582.14 478.797C579.85 478.8 578 479.815 578 481.067C578 482.32 579.85 483.335 582.14 483.338H692.265C694.551 483.335 696.405 482.32 696.405 481.067C696.405 479.815 694.551 478.8 692.265 478.797H582.14Z",
  fill: "#CBD5E6"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M585.539 365C581.925 365.001 579 366.016 579 367.264C579 368.514 581.925 369.527 585.539 369.529H759.461C763.075 369.527 766 368.514 766 367.264C766 366.016 763.075 365.001 759.461 365H585.539Z",
  fill: "#CBD5E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583.14 374.797C580.85 374.8 579 375.815 579 377.067C579 378.32 580.85 379.335 583.14 379.338H693.265C695.551 379.335 697.405 378.32 697.405 377.067C697.405 375.815 695.551 374.8 693.265 374.797H583.14Z",
  fill: "#CBD5E6"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536 516L777.822 516.047L778 560L536.178 559.953L536 516Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M584.539 527C580.925 527.001 578 528.016 578 529.264C578 530.514 580.925 531.527 584.539 531.529H758.461C762.075 531.527 765 530.514 765 529.264C765 528.016 762.075 527.001 758.461 527H584.539Z",
  fill: "#CBD5E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582.14 536.797C579.85 536.8 578 537.815 578 539.067C578 540.32 579.85 541.335 582.14 541.338H692.265C694.551 541.335 696.405 540.32 696.405 539.067C696.405 537.815 694.551 536.8 692.265 536.797H582.14Z",
  fill: "#CBD5E6"
}));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M559.5 533C563.09 533 566 530.09 566 526.5C566 522.91 563.09 520 559.5 520C555.91 520 553 522.91 553 526.5C553 530.09 555.91 533 559.5 533Z",
  fill: "#51B8C6"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M600.239 660.067C608.529 660.067 615.252 653.653 615.252 645.742C615.252 637.831 608.529 631.418 600.239 631.418C591.946 631.418 585.225 637.831 585.225 645.742C585.225 653.653 591.946 660.067 600.239 660.067Z",
  fill: "#06172D"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M600.239 660.067C608.529 660.067 615.252 653.653 615.252 645.742C615.252 637.831 608.529 631.418 600.239 631.418C591.946 631.418 585.225 637.831 585.225 645.742C585.225 653.653 591.946 660.067 600.239 660.067Z",
  fill: "url(#paint4_linear_0_1)"
});

var _ref42 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_0_1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1041.52 566.482H658.281C652.65 566.482 648.084 570.91 648.084 576.371V797.941C648.084 800.735 650.456 803 653.382 803H1046.41C1049.34 803 1051.71 800.735 1051.71 797.941V576.371C1051.71 573.748 1050.64 571.232 1048.73 569.378C1046.81 567.524 1044.22 566.482 1041.52 566.482Z",
  fill: "#06172D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1041.52 566.482H658.281C652.65 566.482 648.084 570.91 648.084 576.371V797.941C648.084 800.735 650.456 803 653.382 803H1046.41C1049.34 803 1051.71 800.735 1051.71 797.941V576.371C1051.71 573.748 1050.64 571.232 1048.73 569.378C1046.81 567.524 1044.22 566.482 1041.52 566.482Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1038.34 573.015H662.689C659.763 573.015 657.391 575.279 657.391 578.074V792.904C657.391 795.698 659.763 797.964 662.689 797.964H1038.34C1041.27 797.964 1043.64 795.698 1043.64 792.904V578.074C1043.64 575.279 1041.27 573.015 1038.34 573.015Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1043.64 577.049H752.016V794.451H1043.64V577.049Z",
  fill: "#DFEAF8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M773.923 586.719L876.777 586.81L876.853 671.77L773.998 671.679L773.923 586.719Z",
  fill: "#E1E8F3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M798.928 628.295L816.398 650.892L781.498 650.863L798.928 628.295Z",
  fill: "#C6D0DF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M837.269 618.364L867.319 656.913L807.29 656.863L837.269 618.364Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M798.921 628.933C805.091 628.933 810.094 624.177 810.094 618.311C810.094 612.445 805.091 607.689 798.921 607.689C792.75 607.689 787.747 612.445 787.747 618.311C787.747 624.177 792.75 628.933 798.921 628.933Z",
  fill: "#F24390"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M777.453 713.349C775.502 713.353 773.923 715.044 773.923 717.129C773.923 719.214 775.502 720.905 777.453 720.909H871.344C873.293 720.905 874.874 719.214 874.874 717.129C874.874 715.044 873.293 713.353 871.344 713.349H777.453Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M777.464 730.361C775.507 730.365 773.923 732.057 773.923 734.142C773.923 736.226 775.507 737.918 777.464 737.922H819.867C821.824 737.918 823.408 736.226 823.408 734.142C823.408 732.057 821.824 730.365 819.867 730.361H777.464Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M777.453 696.34C775.502 696.344 773.923 698.035 773.923 700.121C773.923 702.205 775.502 703.896 777.453 703.9H871.344C873.293 703.896 874.874 702.205 874.874 700.121C874.874 698.035 873.293 696.344 871.344 696.34H777.453Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M911.684 586.719L1014.54 586.81L1014.61 671.77L911.759 671.679L911.684 586.719Z",
  fill: "#E1E8F3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M936.688 628.295L954.159 650.892L919.259 650.863L936.688 628.295Z",
  fill: "#C6D0DF"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M975.03 618.364L1005.08 656.913L945.051 656.863L975.03 618.364Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M936.682 628.933C942.852 628.933 947.855 624.177 947.855 618.311C947.855 612.445 942.852 607.689 936.682 607.689C930.51 607.689 925.507 612.445 925.507 618.311C925.507 624.177 930.51 628.933 936.682 628.933Z",
  fill: "#F24390"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M915.214 713.349C913.263 713.353 911.684 715.044 911.684 717.129C911.684 719.214 913.263 720.905 915.214 720.909H1009.1C1011.05 720.905 1012.63 719.214 1012.63 717.129C1012.63 715.044 1011.05 713.353 1009.1 713.349H915.214Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M915.224 730.361C913.268 730.365 911.684 732.057 911.684 734.142C911.684 736.226 913.268 737.918 915.224 737.922H957.628C959.585 737.918 961.169 736.226 961.169 734.142C961.169 732.057 959.585 730.365 957.628 730.361H915.224Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M915.214 696.34C913.263 696.344 911.684 698.035 911.684 700.121C911.684 702.205 913.263 703.896 915.214 703.9H1009.1C1011.05 703.896 1012.63 702.205 1012.63 700.121C1012.63 698.035 1011.05 696.344 1009.1 696.34H915.214Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M742.755 576.28H664.158C662.694 576.28 661.509 577.412 661.509 578.81V792.578C661.509 793.976 662.694 795.108 664.158 795.108H742.755C744.218 795.108 745.404 793.976 745.404 792.578V578.81C745.404 577.414 744.218 576.28 742.755 576.28Z",
  fill: "#C6D7EE"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M673.799 608.94C672.57 608.942 671.575 609.955 671.575 611.205C671.575 612.453 672.57 613.467 673.799 613.469H732.95C734.179 613.467 735.174 612.453 735.174 611.205C735.174 609.955 734.179 608.942 732.95 608.94H673.799Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.983 618.738C672.204 618.741 671.575 619.757 671.575 621.009C671.575 622.261 672.204 623.276 672.983 623.279H710.436C711.214 623.276 711.845 622.261 711.845 621.009C711.845 619.757 711.214 618.741 710.436 618.738H672.983Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M701.776 602.408C705.483 602.408 708.488 599.483 708.488 595.876C708.488 592.268 705.483 589.344 701.776 589.344C698.069 589.344 695.064 592.268 695.064 595.876C695.064 599.483 698.069 602.408 701.776 602.408Z",
  fill: "#466089"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M673.799 641.602C672.57 641.604 671.575 642.618 671.575 643.866C671.575 645.116 672.57 646.129 673.799 646.132H732.95C734.179 646.129 735.174 645.116 735.174 643.866C735.174 642.618 734.179 641.604 732.95 641.602H673.799Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.983 651.399C672.204 651.402 671.575 652.418 671.575 653.67C671.575 654.922 672.204 655.938 672.983 655.94H710.436C711.214 655.938 711.845 654.922 711.845 653.67C711.845 652.418 711.214 651.402 710.436 651.399H672.983Z",
  fill: "#466089"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M673.799 674.262C672.57 674.265 671.575 675.278 671.575 676.527C671.575 677.776 672.57 678.789 673.799 678.791H732.95C734.179 678.789 735.174 677.776 735.174 676.527C735.174 675.278 734.179 674.265 732.95 674.262H673.799Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.983 684.06C672.204 684.063 671.575 685.079 671.575 686.331C671.575 687.582 672.204 688.597 672.983 688.6H710.436C711.214 688.597 711.845 687.582 711.845 686.331C711.845 685.079 711.214 684.063 710.436 684.06H672.983Z",
  fill: "#466089"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M673.799 706.923C672.57 706.926 671.575 707.939 671.575 709.188C671.575 710.437 672.57 711.45 673.799 711.452H732.95C734.179 711.45 735.174 710.437 735.174 709.188C735.174 707.939 734.179 706.926 732.95 706.923H673.799Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M672.983 716.721C672.204 716.724 671.575 717.738 671.575 718.991C671.575 720.243 672.204 721.258 672.983 721.261H710.436C711.214 721.258 711.845 720.243 711.845 718.991C711.845 717.738 711.214 716.724 710.436 716.721H672.983Z",
  fill: "url(#paint5_linear_0_1)"
})));

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M154 561.483C154 548.177 165.296 537.391 179.231 537.391H261.231C275.166 537.391 286.462 548.177 286.462 561.483V766.26C286.462 779.566 275.166 790.352 261.231 790.352H179.231C165.296 790.352 154 779.566 154 766.26V561.483Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M259.97 582.924H181.817C180.354 582.924 179.168 584.056 179.168 585.454V742.289C179.168 743.687 180.354 744.819 181.817 744.819H259.97C261.433 744.819 262.619 743.687 262.619 742.289V585.454C262.619 584.056 261.433 582.924 259.97 582.924Z",
  fill: "#C6D7EE"
});

var _ref45 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.458 615.584C190.229 615.587 189.234 616.6 189.234 617.849C189.234 619.098 190.229 620.111 191.458 620.113H250.61C251.838 620.111 252.834 619.098 252.834 617.849C252.834 616.6 251.838 615.587 250.61 615.584H191.458Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.643 625.382C189.865 625.385 189.234 626.401 189.234 627.653C189.234 628.905 189.865 629.921 190.643 629.923H228.096C228.874 629.921 229.503 628.905 229.503 627.653C229.503 626.401 228.874 625.385 228.096 625.382H190.643Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.436 609.052C223.142 609.052 226.147 606.127 226.147 602.52C226.147 598.912 223.142 595.988 219.436 595.988C215.729 595.988 212.724 598.912 212.724 602.52C212.724 606.127 215.729 609.052 219.436 609.052Z",
  fill: "#F24390"
}));

var _ref46 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.458 648.246C190.229 648.247 189.234 649.261 189.234 650.51C189.234 651.76 190.229 652.773 191.458 652.774H250.61C251.838 652.773 252.834 651.76 252.834 650.51C252.834 649.261 251.838 648.247 250.61 648.246H191.458Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.643 658.043C189.865 658.046 189.234 659.062 189.234 660.314C189.234 661.566 189.865 662.582 190.643 662.583H228.096C228.874 662.582 229.503 661.566 229.503 660.314C229.503 659.062 228.874 658.046 228.096 658.043H190.643Z",
  fill: "#466089"
}));

var _ref47 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.458 680.906C190.229 680.909 189.234 681.922 189.234 683.171C189.234 684.42 190.229 685.433 191.458 685.435H250.61C251.838 685.433 252.834 684.42 252.834 683.171C252.834 681.922 251.838 680.909 250.61 680.906H191.458Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.643 690.704C189.865 690.707 189.234 691.723 189.234 692.975C189.234 694.226 189.865 695.241 190.643 695.244H228.096C228.874 695.241 229.503 694.226 229.503 692.975C229.503 691.723 228.874 690.707 228.096 690.704H190.643Z",
  fill: "#466089"
}));

var _ref48 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.458 713.567C190.229 713.57 189.234 714.583 189.234 715.831C189.234 717.081 190.229 718.094 191.458 718.096H250.61C251.838 718.094 252.834 717.081 252.834 715.831C252.834 714.583 251.838 713.57 250.61 713.567H191.458Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.643 723.366C189.865 723.367 189.234 724.382 189.234 725.635C189.234 726.887 189.865 727.902 190.643 727.905H228.096C228.874 727.902 229.503 726.887 229.503 725.635C229.503 724.382 228.874 723.367 228.096 723.366H190.643Z",
  fill: "url(#paint6_linear_0_1)"
}));

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M261.231 543.414H179.231C168.78 543.414 160.308 551.504 160.308 561.483V766.26C160.308 776.239 168.78 784.329 179.231 784.329H261.231C271.682 784.329 280.154 776.239 280.154 766.26V561.483C280.154 551.504 271.682 543.414 261.231 543.414ZM179.231 537.391C165.296 537.391 154 548.177 154 561.483V766.26C154 779.566 165.296 790.352 179.231 790.352H261.231C275.166 790.352 286.462 779.566 286.462 766.26V561.483C286.462 548.177 275.166 537.391 261.231 537.391H179.231Z",
  fill: "#C6D7EE"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M185.539 537.391H254.923V558.954C254.923 560.35 253.737 561.483 252.274 561.483H188.188C186.725 561.483 185.539 560.35 185.539 558.954V537.391Z",
  fill: "#C6D7EE"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M797.001 321C803.075 321 808 316.075 808 310C808 303.925 803.075 299 797.001 299C790.925 299 786 303.925 786 310C786 316.075 790.925 321 797.001 321Z",
  fill: "#F24390"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M599.184 187.156C652.858 187.156 696.368 145.26 696.368 93.5781C696.368 41.8964 652.858 0 599.184 0C545.511 0 502 41.8964 502 93.5781C502 145.26 545.511 187.156 599.184 187.156Z",
  fill: "#EEEDF2"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M673.966 187.156H696.594",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M522.059 187.156H667.88",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M502.18 187.156H515.883",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M621.136 61.5028V91.4513C621.136 91.7985 621.587 91.9722 621.812 91.7117L629.16 84.637C630.287 83.5519 631.819 82.9442 633.397 82.9442H665.626C670.179 82.9442 673.875 79.3851 673.875 75.0014V57.3361C673.875 52.9523 670.179 49.3932 665.626 49.3932H633.713C626.771 49.3932 621.136 54.8187 621.136 61.5028Z",
  fill: "#D3D5E7"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M614.33 47.6571V77.6056C614.33 77.9528 614.781 78.1265 615.006 77.866L622.353 70.7913C623.48 69.7062 625.013 69.0985 626.59 69.0985H658.82C663.373 69.0985 667.069 65.5394 667.069 61.1557V43.4904C667.069 39.1066 663.373 35.5475 658.82 35.5475H626.906C619.964 35.5475 614.33 40.973 614.33 47.6571Z",
  fill: "white",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M627.041 58.5948H654.357",
  stroke: "#1E247E",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M627.041 52.4315H654.357",
  stroke: "#1E247E",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M627.041 46.3116H654.357",
  stroke: "#1E247E",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M619.198 67.4058C620.28 65.9734 621.993 65.1054 623.841 64.9752",
  stroke: "#1E247E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M592.738 43.9678V73.9163C592.738 74.2635 592.288 74.4371 592.062 74.1767L584.715 67.1019C583.588 66.0168 582.055 65.4092 580.478 65.4092H548.248C543.695 65.4092 539.999 61.8501 539.999 57.4663V39.8011C539.999 35.4173 543.695 31.8582 548.248 31.8582H580.162C587.149 31.8582 592.738 37.2837 592.738 43.9678Z",
  fill: "#D3D5E7"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M581.109 27.9953V57.9438C581.109 58.291 580.658 58.4646 580.432 58.2042L573.085 51.1294C571.958 50.0443 570.426 49.4366 568.848 49.4366H536.618C532.066 49.4366 528.37 45.8776 528.37 41.4938V23.8285C528.37 19.4448 532.066 15.8857 536.618 15.8857H568.532C575.519 15.8857 581.109 21.3111 581.109 27.9953Z",
  fill: "white",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M571.868 21.2678C573.626 21.832 575.023 23.1341 575.699 24.74",
  stroke: "#1E247E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M539.053 38.5858H566.369",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M539.053 32.4225H566.369",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M539.053 26.3026H551.133",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M590.214 186.896H536.348V160.984C536.348 146.661 548.383 135.072 563.259 135.072C578.134 135.072 590.169 146.661 590.169 160.984V186.896H590.214Z",
  fill: "#D3D5E7",
  stroke: "#3B247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M563.259 128.475C570.677 128.475 576.691 122.684 576.691 115.54C576.691 108.397 570.677 102.606 563.259 102.606C555.84 102.606 549.826 108.397 549.826 115.54C549.826 122.684 555.84 128.475 563.259 128.475Z",
  fill: "#FCF5F2",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M575.654 145.142C578.043 147.051 579.892 149.482 581.019 152.216",
  stroke: "#1E247E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M548.834 156.6L552.44 159.248",
  stroke: "#1E247E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M548.834 153.258L556.091 158.597",
  stroke: "#1E247E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M554.108 153.692L556.091 155.168",
  stroke: "#1E247E",
  strokeWidth: 3.90625,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M582.686 97.7449L578.9 98.7866",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M578.629 92.493L575.564 95.5747",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M571.688 92.9705L572.364 88.9774",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M661.795 186.766H607.929V160.854C607.929 146.531 619.964 134.942 634.839 134.942C649.715 134.942 661.75 146.531 661.75 160.854V186.766H661.795Z",
  fill: "#3B82FF",
  stroke: "#1E247E",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M634.839 128.388C642.258 128.388 648.272 122.597 648.272 115.453C648.272 108.31 642.258 102.519 634.839 102.519C627.421 102.519 621.407 108.31 621.407 115.453C621.407 122.597 627.421 128.388 634.839 128.388Z",
  fill: "#FCF5F2",
  stroke: "#1E247E",
  strokeWidth: 5,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M647.235 144.317C649.624 146.227 651.473 148.657 652.599 151.392",
  stroke: "#1E247E",
  strokeWidth: 4.6875,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M616.448 99.5244L613.924 96.3126",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M609.101 108.683L612.932 107.945",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M610.138 102.259L614.33 103.604",
  stroke: "white",
  strokeWidth: 10.9375,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M455.701 306.668H462.562C464.063 306.668 465.439 307.821 465.439 309.258V314.89C465.423 315.575 465.114 316.228 464.577 316.711C464.041 317.194 463.318 317.47 462.562 317.48H452.671V303H455.696L455.701 306.668ZM462.416 309.843C462.417 309.746 462.397 309.649 462.357 309.559C462.316 309.469 462.256 309.388 462.181 309.319C462.105 309.25 462.015 309.196 461.915 309.16C461.816 309.123 461.71 309.105 461.602 309.107H455.698V315.041H461.602C461.71 315.042 461.816 315.024 461.916 314.988C462.015 314.951 462.105 314.897 462.181 314.828C462.257 314.759 462.317 314.678 462.357 314.587C462.398 314.497 462.417 314.401 462.416 314.304V309.843Z",
  fill: "#495870"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M478.577 306.668C479.333 306.674 480.057 306.949 480.592 307.433C481.127 307.917 481.431 308.573 481.439 309.258V314.89C481.435 315.575 481.132 316.232 480.597 316.717C480.062 317.202 479.338 317.476 478.581 317.48H471.32C470.566 317.469 469.846 317.193 469.313 316.71C468.78 316.226 468.475 315.573 468.464 314.89V309.258C468.475 308.574 468.78 307.922 469.313 307.438C469.846 306.955 470.566 306.678 471.32 306.668H478.577ZM478.41 309.843C478.412 309.746 478.392 309.649 478.352 309.559C478.311 309.469 478.251 309.387 478.175 309.319C478.1 309.25 478.009 309.196 477.91 309.16C477.811 309.123 477.704 309.105 477.597 309.107H472.3C472.193 309.105 472.087 309.123 471.987 309.16C471.888 309.196 471.798 309.25 471.722 309.319C471.646 309.387 471.586 309.469 471.546 309.559C471.505 309.649 471.485 309.746 471.487 309.843V314.304C471.485 314.401 471.505 314.497 471.546 314.588C471.586 314.678 471.646 314.76 471.722 314.828C471.797 314.897 471.888 314.951 471.987 314.988C472.087 315.024 472.193 315.042 472.3 315.041H477.601C477.709 315.042 477.815 315.024 477.914 314.988C478.014 314.951 478.104 314.897 478.18 314.828C478.256 314.76 478.316 314.678 478.356 314.588C478.396 314.497 478.416 314.401 478.415 314.304L478.41 309.843Z",
  fill: "#495870"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M494.093 310.884C494.85 310.888 495.574 311.162 496.109 311.647C496.644 312.132 496.947 312.788 496.951 313.474V314.891C496.947 315.577 496.644 316.233 496.109 316.718C495.574 317.203 494.85 317.477 494.093 317.481H484.458V315.081H493.134C493.241 315.082 493.348 315.064 493.447 315.028C493.546 314.991 493.637 314.937 493.713 314.868C493.788 314.8 493.848 314.718 493.889 314.628C493.929 314.537 493.949 314.441 493.947 314.344V314.003C493.949 313.905 493.929 313.809 493.889 313.719C493.848 313.629 493.788 313.547 493.713 313.478C493.637 313.41 493.546 313.356 493.447 313.319C493.347 313.283 493.241 313.265 493.134 313.267H487.316C486.941 313.268 486.568 313.201 486.221 313.072C485.874 312.942 485.558 312.751 485.293 312.51C485.027 312.27 484.817 311.984 484.674 311.669C484.53 311.354 484.457 311.017 484.458 310.676V309.259C484.459 308.573 484.761 307.914 485.297 307.429C485.832 306.943 486.559 306.67 487.316 306.669H496.951V309.069H488.276C488.168 309.065 488.06 309.081 487.959 309.116C487.858 309.151 487.766 309.206 487.689 309.275C487.613 309.344 487.553 309.428 487.514 309.519C487.475 309.611 487.457 309.708 487.462 309.806V310.128C487.457 310.227 487.474 310.326 487.513 310.418C487.551 310.511 487.611 310.596 487.687 310.667C487.763 310.738 487.855 310.793 487.956 310.831C488.058 310.868 488.166 310.886 488.276 310.884H494.093Z",
  fill: "#495870"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M435.409 321.373C435.301 321.372 435.197 321.333 435.121 321.263C435.044 321.194 435.001 321.1 435 321.002V319.827H435.433V320.919C435.432 320.933 435.434 320.947 435.44 320.96C435.446 320.973 435.454 320.985 435.465 320.994C435.476 321.004 435.489 321.012 435.504 321.017C435.518 321.022 435.534 321.024 435.549 321.023H436.318V319.827H436.751V321.373H435.409Z",
  fill: "#495870"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M437.541 319.827H438.521C438.629 319.828 438.732 319.868 438.809 319.936C438.886 320.005 438.93 320.098 438.933 320.196V320.999C438.93 321.097 438.886 321.191 438.809 321.26C438.732 321.329 438.629 321.368 438.521 321.37H437.108V319.3H437.541V319.827ZM438.5 320.281C438.5 320.267 438.498 320.253 438.492 320.24C438.486 320.227 438.478 320.215 438.467 320.205C438.456 320.195 438.443 320.187 438.429 320.182C438.414 320.177 438.399 320.175 438.383 320.175H437.541V321.023H438.383C438.399 321.024 438.414 321.021 438.428 321.016C438.442 321.011 438.455 321.003 438.466 320.994C438.477 320.984 438.486 320.972 438.492 320.959C438.497 320.947 438.5 320.933 438.5 320.919V320.281Z",
  fill: "#495870"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M440.639 319.827V320.175H439.811C439.795 320.174 439.78 320.176 439.765 320.181C439.751 320.187 439.738 320.194 439.727 320.204C439.716 320.214 439.707 320.226 439.701 320.239C439.696 320.253 439.693 320.267 439.694 320.281V321.373H439.262V320.196C439.263 320.098 439.306 320.005 439.383 319.936C439.459 319.866 439.563 319.827 439.671 319.827H440.639Z",
  fill: "#495870"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M442.159 319.827C442.213 319.827 442.266 319.836 442.316 319.855C442.365 319.873 442.41 319.901 442.448 319.935C442.486 319.969 442.516 320.01 442.536 320.055C442.557 320.1 442.567 320.148 442.567 320.196V321.373H441.169C441.061 321.372 440.957 321.333 440.88 321.264C440.804 321.194 440.76 321.1 440.76 321.002V320.8C440.76 320.702 440.804 320.608 440.88 320.538C440.957 320.469 441.061 320.43 441.169 320.429H442.136V320.275C442.136 320.261 442.134 320.247 442.128 320.234C442.123 320.221 442.114 320.209 442.103 320.199C442.092 320.189 442.079 320.182 442.065 320.177C442.05 320.171 442.035 320.169 442.019 320.17H440.865V319.827H442.159ZM442.136 321.031V320.772H441.309C441.278 320.772 441.249 320.783 441.227 320.803C441.205 320.823 441.193 320.849 441.193 320.878V320.927C441.193 320.941 441.196 320.954 441.201 320.967C441.207 320.98 441.216 320.992 441.227 321.001C441.238 321.011 441.251 321.019 441.265 321.024C441.279 321.029 441.294 321.032 441.309 321.031H442.136Z",
  fill: "#495870"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M443.354 319.302V319.65H442.921V319.302H443.354ZM443.354 319.827V321.372H442.921V319.827H443.354Z",
  fill: "#495870"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M445.125 319.827C445.233 319.828 445.336 319.867 445.413 319.936C445.489 320.005 445.533 320.098 445.534 320.196V321.373H445.101V320.281C445.102 320.267 445.1 320.253 445.094 320.239C445.089 320.226 445.08 320.214 445.069 320.204C445.058 320.194 445.045 320.187 445.031 320.181C445.016 320.176 445 320.174 444.985 320.175H444.145V321.373H443.712V319.827H445.125Z",
  fill: "#495870"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M445.863 320.196C445.863 320.148 445.874 320.1 445.894 320.055C445.915 320.01 445.945 319.969 445.983 319.935C446.021 319.9 446.066 319.873 446.116 319.855C446.165 319.836 446.219 319.827 446.272 319.827H447.292C447.4 319.827 447.504 319.866 447.581 319.935C447.657 320.004 447.701 320.098 447.701 320.196V320.4C447.701 320.448 447.691 320.497 447.67 320.541C447.649 320.586 447.619 320.627 447.581 320.661C447.543 320.696 447.498 320.723 447.449 320.741C447.399 320.76 447.346 320.769 447.292 320.769H446.296V320.919C446.295 320.933 446.298 320.947 446.303 320.96C446.309 320.973 446.318 320.985 446.329 320.994C446.34 321.004 446.353 321.012 446.367 321.017C446.382 321.022 446.397 321.024 446.412 321.023H447.635V321.367H446.281C446.173 321.367 446.069 321.328 445.992 321.258C445.916 321.189 445.873 321.095 445.872 320.997L445.863 320.196ZM446.412 320.17C446.397 320.169 446.381 320.171 446.367 320.177C446.353 320.182 446.339 320.189 446.329 320.199C446.318 320.209 446.309 320.221 446.303 320.234C446.298 320.247 446.295 320.261 446.296 320.275V320.437H447.152C447.167 320.438 447.183 320.435 447.197 320.43C447.212 320.425 447.225 320.417 447.236 320.408C447.247 320.398 447.255 320.386 447.261 320.373C447.267 320.36 447.269 320.346 447.269 320.332V320.275C447.269 320.261 447.267 320.247 447.261 320.234C447.255 320.221 447.247 320.209 447.236 320.199C447.225 320.189 447.212 320.182 447.197 320.177C447.183 320.171 447.167 320.169 447.152 320.17H446.412Z",
  fill: "#495870"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M449.582 319.827H450.562C450.67 319.828 450.774 319.867 450.85 319.936C450.927 320.005 450.971 320.098 450.974 320.196V320.999C450.971 321.097 450.927 321.191 450.85 321.26C450.774 321.329 450.67 321.368 450.562 321.37H449.149V319.3H449.582V319.827ZM450.541 320.281C450.542 320.267 450.539 320.253 450.533 320.24C450.527 320.227 450.519 320.215 450.508 320.205C450.497 320.195 450.484 320.187 450.47 320.182C450.455 320.177 450.44 320.175 450.425 320.175H449.582V321.023H450.425C450.44 321.024 450.455 321.021 450.469 321.016C450.484 321.011 450.497 321.003 450.508 320.994C450.518 320.984 450.527 320.972 450.533 320.959C450.539 320.947 450.541 320.933 450.541 320.919V320.281Z",
  fill: "#495870"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M451.712 321.373C451.604 321.372 451.5 321.333 451.424 321.263C451.347 321.194 451.304 321.1 451.303 321.002V319.827H451.735V320.919C451.735 320.933 451.737 320.947 451.743 320.96C451.749 320.973 451.757 320.985 451.768 320.994C451.779 321.004 451.792 321.012 451.807 321.017C451.821 321.022 451.837 321.024 451.852 321.023H452.621V319.827H453.054V321.373H451.712Z",
  fill: "#495870"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M454.76 320.429C454.869 320.43 454.972 320.469 455.049 320.538C455.126 320.608 455.169 320.702 455.169 320.8V321.002C455.169 321.1 455.126 321.194 455.049 321.264C454.972 321.333 454.869 321.372 454.76 321.373H453.414V321.029H454.624C454.64 321.029 454.655 321.026 454.669 321.021C454.683 321.016 454.696 321.008 454.706 320.998C454.717 320.989 454.726 320.977 454.731 320.964C454.737 320.952 454.74 320.938 454.74 320.924V320.875C454.74 320.861 454.737 320.847 454.731 320.834C454.726 320.822 454.717 320.81 454.706 320.8C454.696 320.79 454.683 320.782 454.669 320.777C454.655 320.772 454.64 320.769 454.624 320.769H453.792C453.738 320.769 453.685 320.76 453.636 320.741C453.586 320.723 453.541 320.696 453.503 320.661C453.465 320.627 453.435 320.586 453.414 320.541C453.394 320.497 453.383 320.448 453.383 320.4V320.196C453.383 320.098 453.427 320.004 453.503 319.935C453.58 319.866 453.684 319.827 453.792 319.827H455.066V320.17H453.929C453.914 320.169 453.898 320.171 453.884 320.177C453.869 320.182 453.856 320.189 453.845 320.199C453.834 320.209 453.826 320.221 453.82 320.234C453.815 320.247 453.812 320.261 453.813 320.275V320.321C453.812 320.335 453.814 320.349 453.82 320.362C453.825 320.376 453.834 320.388 453.845 320.398C453.856 320.408 453.869 320.416 453.883 320.422C453.898 320.427 453.914 320.43 453.929 320.429H454.76Z",
  fill: "#495870"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M455.931 319.302V319.65H455.5V319.302H455.931ZM455.931 319.827V321.372H455.5V319.827H455.931Z",
  fill: "#495870"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M457.702 319.827C457.81 319.828 457.913 319.867 457.99 319.936C458.066 320.005 458.11 320.099 458.111 320.196V321.373H457.673V320.281C457.673 320.267 457.671 320.253 457.665 320.24C457.66 320.227 457.651 320.215 457.64 320.205C457.629 320.195 457.616 320.187 457.602 320.182C457.587 320.177 457.572 320.174 457.556 320.175H456.715V321.373H456.284V319.827H457.702Z",
  fill: "#495870"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M458.44 320.196C458.44 320.148 458.451 320.1 458.471 320.055C458.492 320.01 458.522 319.969 458.56 319.934C458.598 319.9 458.643 319.873 458.693 319.854C458.742 319.836 458.796 319.827 458.849 319.827H459.868C459.976 319.827 460.08 319.866 460.157 319.935C460.233 320.004 460.276 320.098 460.277 320.196V320.4C460.277 320.449 460.267 320.497 460.246 320.542C460.226 320.587 460.195 320.627 460.157 320.662C460.119 320.696 460.074 320.723 460.025 320.742C459.975 320.76 459.922 320.769 459.868 320.769H458.873V320.919C458.872 320.933 458.875 320.947 458.881 320.96C458.886 320.973 458.895 320.985 458.906 320.994C458.917 321.004 458.93 321.012 458.944 321.017C458.959 321.022 458.974 321.024 458.99 321.023H460.203V321.367H458.854C458.745 321.367 458.641 321.328 458.565 321.259C458.488 321.189 458.445 321.095 458.445 320.997L458.44 320.196ZM458.99 320.17C458.974 320.169 458.958 320.171 458.944 320.176C458.929 320.181 458.916 320.189 458.905 320.199C458.894 320.209 458.886 320.221 458.88 320.234C458.875 320.247 458.872 320.261 458.873 320.275V320.437H459.728C459.743 320.438 459.759 320.436 459.773 320.431C459.788 320.426 459.801 320.418 459.812 320.408C459.823 320.398 459.832 320.386 459.837 320.373C459.843 320.36 459.845 320.346 459.844 320.332V320.275C459.845 320.261 459.843 320.247 459.837 320.234C459.832 320.221 459.823 320.209 459.812 320.199C459.801 320.189 459.788 320.181 459.773 320.176C459.759 320.171 459.743 320.169 459.728 320.17H458.99Z",
  fill: "#495870"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M461.954 320.429C462.062 320.43 462.166 320.469 462.243 320.538C462.319 320.608 462.362 320.702 462.363 320.8V321.002C462.362 321.1 462.319 321.194 462.243 321.264C462.166 321.333 462.062 321.372 461.954 321.373H460.61V321.029H461.821C461.836 321.029 461.851 321.026 461.865 321.021C461.879 321.016 461.892 321.008 461.903 320.998C461.914 320.989 461.922 320.977 461.928 320.964C461.933 320.952 461.936 320.938 461.936 320.924V320.875C461.936 320.861 461.933 320.847 461.928 320.834C461.922 320.822 461.914 320.81 461.903 320.8C461.892 320.79 461.879 320.782 461.865 320.777C461.851 320.772 461.836 320.769 461.821 320.769H460.988C460.935 320.769 460.882 320.76 460.832 320.741C460.782 320.723 460.737 320.696 460.699 320.661C460.661 320.627 460.631 320.586 460.611 320.541C460.59 320.497 460.579 320.448 460.579 320.4V320.196C460.58 320.098 460.623 320.004 460.7 319.935C460.776 319.866 460.88 319.827 460.988 319.827H462.261V320.17H461.126C461.11 320.169 461.095 320.171 461.08 320.176C461.066 320.181 461.052 320.189 461.041 320.199C461.03 320.209 461.022 320.221 461.016 320.234C461.011 320.247 461.008 320.261 461.009 320.275V320.321C461.008 320.335 461.011 320.349 461.016 320.362C461.022 320.376 461.03 320.388 461.041 320.398C461.052 320.408 461.065 320.416 461.08 320.422C461.094 320.427 461.11 320.43 461.126 320.429H461.954Z",
  fill: "#495870"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M463.986 320.429C464.095 320.43 464.199 320.469 464.275 320.538C464.352 320.608 464.395 320.702 464.395 320.8V321.002C464.395 321.1 464.352 321.194 464.275 321.264C464.199 321.333 464.095 321.372 463.986 321.373H462.639V321.029H463.849C463.865 321.029 463.88 321.027 463.894 321.021C463.908 321.016 463.921 321.009 463.932 320.999C463.943 320.989 463.951 320.978 463.957 320.965C463.963 320.952 463.966 320.938 463.966 320.924V320.875C463.966 320.861 463.963 320.847 463.957 320.834C463.952 320.821 463.943 320.81 463.932 320.8C463.921 320.79 463.908 320.782 463.894 320.777C463.88 320.772 463.865 320.769 463.849 320.769H463.018C462.965 320.769 462.911 320.76 462.861 320.742C462.812 320.723 462.767 320.696 462.729 320.662C462.691 320.627 462.66 320.587 462.64 320.542C462.62 320.497 462.609 320.448 462.609 320.4V320.196C462.61 320.098 462.653 320.004 462.73 319.935C462.806 319.866 462.91 319.827 463.018 319.827H464.291V320.17H463.155C463.14 320.169 463.124 320.171 463.11 320.176C463.095 320.181 463.082 320.189 463.071 320.199C463.06 320.209 463.051 320.221 463.046 320.234C463.04 320.247 463.038 320.261 463.039 320.275V320.321C463.038 320.335 463.04 320.349 463.046 320.362C463.051 320.376 463.06 320.388 463.071 320.398C463.082 320.408 463.095 320.416 463.11 320.422C463.124 320.427 463.14 320.43 463.155 320.429H463.986Z",
  fill: "#495870"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M467.268 319.827C467.376 319.828 467.479 319.867 467.555 319.936C467.631 320.006 467.674 320.099 467.675 320.196V320.999C467.675 321.097 467.632 321.191 467.556 321.26C467.48 321.33 467.376 321.369 467.268 321.37H466.235C466.127 321.368 466.024 321.329 465.947 321.26C465.871 321.191 465.827 321.097 465.826 320.999V320.196C465.828 320.099 465.872 320.006 465.948 319.937C466.024 319.868 466.127 319.828 466.235 319.827H467.268ZM467.243 320.281C467.243 320.267 467.241 320.253 467.235 320.24C467.23 320.227 467.221 320.215 467.21 320.206C467.2 320.196 467.187 320.188 467.173 320.183C467.158 320.177 467.143 320.175 467.128 320.175H466.371C466.355 320.175 466.34 320.177 466.325 320.182C466.311 320.187 466.298 320.195 466.287 320.205C466.276 320.215 466.268 320.227 466.262 320.24C466.256 320.253 466.254 320.267 466.254 320.281V320.919C466.254 320.933 466.257 320.947 466.262 320.959C466.268 320.972 466.277 320.984 466.288 320.994C466.299 321.003 466.312 321.011 466.326 321.016C466.34 321.021 466.355 321.024 466.371 321.023H467.12C467.136 321.023 467.151 321.021 467.165 321.016C467.179 321.01 467.192 321.003 467.202 320.993C467.213 320.983 467.222 320.972 467.227 320.959C467.233 320.946 467.236 320.933 467.236 320.919L467.243 320.281Z",
  fill: "#495870"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M469.416 319.827C469.524 319.828 469.627 319.867 469.704 319.936C469.78 320.005 469.824 320.099 469.825 320.196V320.999C469.824 321.097 469.781 321.191 469.705 321.261C469.628 321.33 469.524 321.369 469.416 321.37H468.436V321.878H467.993V319.824L469.416 319.827ZM469.392 320.281C469.393 320.267 469.391 320.253 469.385 320.239C469.38 320.226 469.371 320.214 469.36 320.204C469.349 320.194 469.336 320.186 469.321 320.181C469.307 320.176 469.291 320.174 469.276 320.175H468.436V321.023H469.276C469.291 321.024 469.307 321.022 469.321 321.017C469.335 321.012 469.348 321.004 469.36 320.994C469.37 320.985 469.379 320.973 469.385 320.96C469.39 320.947 469.393 320.933 469.392 320.919V320.281Z",
  fill: "#495870"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M470.127 320.196C470.127 320.148 470.138 320.1 470.158 320.055C470.179 320.01 470.209 319.969 470.247 319.934C470.285 319.9 470.33 319.873 470.38 319.854C470.429 319.836 470.483 319.827 470.536 319.827H471.549C471.657 319.827 471.761 319.866 471.838 319.935C471.914 320.004 471.957 320.098 471.958 320.196V320.4C471.958 320.449 471.948 320.497 471.927 320.542C471.907 320.587 471.877 320.627 471.838 320.662C471.8 320.696 471.755 320.723 471.706 320.742C471.656 320.76 471.603 320.769 471.549 320.769H470.56V320.919C470.559 320.933 470.562 320.947 470.567 320.96C470.573 320.973 470.582 320.985 470.593 320.994C470.604 321.004 470.617 321.012 470.631 321.017C470.646 321.022 470.661 321.024 470.677 321.023H471.89V321.367H470.536C470.428 321.367 470.324 321.328 470.247 321.259C470.171 321.189 470.127 321.095 470.127 320.997V320.196ZM470.677 320.17C470.661 320.169 470.645 320.171 470.631 320.176C470.616 320.181 470.603 320.189 470.592 320.199C470.581 320.209 470.573 320.221 470.567 320.234C470.562 320.247 470.559 320.261 470.56 320.275V320.437H471.416C471.432 320.438 471.447 320.435 471.461 320.43C471.476 320.425 471.489 320.417 471.5 320.407C471.51 320.398 471.519 320.386 471.524 320.373C471.53 320.359 471.532 320.346 471.531 320.332V320.275C471.532 320.261 471.53 320.247 471.524 320.234C471.519 320.221 471.51 320.209 471.5 320.199C471.489 320.189 471.476 320.182 471.461 320.177C471.447 320.171 471.432 320.169 471.416 320.17H470.677Z",
  fill: "#495870"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M473.672 319.827V320.175H472.842C472.827 320.174 472.811 320.177 472.797 320.182C472.782 320.187 472.769 320.195 472.758 320.205C472.747 320.215 472.739 320.227 472.733 320.24C472.727 320.253 472.725 320.267 472.726 320.281V321.373H472.294V320.196C472.295 320.099 472.338 320.005 472.415 319.936C472.491 319.867 472.594 319.828 472.702 319.827H473.672Z",
  fill: "#495870"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M475.191 319.827C475.244 319.827 475.298 319.836 475.347 319.854C475.397 319.873 475.442 319.9 475.48 319.934C475.518 319.969 475.548 320.01 475.569 320.055C475.589 320.1 475.6 320.148 475.6 320.196V321.373H474.206C474.098 321.373 473.994 321.334 473.917 321.264C473.84 321.194 473.797 321.1 473.797 321.002V320.8C473.797 320.702 473.84 320.607 473.917 320.538C473.994 320.468 474.098 320.429 474.206 320.429H475.172V320.275C475.172 320.261 475.17 320.247 475.164 320.234C475.159 320.221 475.15 320.209 475.139 320.199C475.128 320.189 475.115 320.181 475.101 320.176C475.086 320.171 475.071 320.169 475.055 320.17H473.902V319.827H475.191ZM475.167 321.031V320.772H474.342C474.327 320.772 474.311 320.774 474.297 320.779C474.283 320.785 474.27 320.793 474.259 320.802C474.248 320.812 474.24 320.824 474.234 320.837C474.228 320.85 474.225 320.864 474.225 320.878V320.927C474.225 320.941 474.228 320.955 474.234 320.967C474.24 320.98 474.248 320.992 474.259 321.002C474.27 321.011 474.283 321.019 474.297 321.024C474.312 321.029 474.327 321.032 474.342 321.031H475.167Z",
  fill: "#495870"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M477.56 320.175H476.899V321.372H476.466V320.175H475.806V319.827H476.466V319.478H476.899V319.827H477.56V320.175Z",
  fill: "#495870"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M478.201 319.302V319.65H477.768V319.302H478.201ZM478.201 319.827V321.372H477.768V319.827H478.201Z",
  fill: "#495870"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M479.971 319.827C480.079 319.828 480.182 319.867 480.259 319.936C480.335 320.005 480.378 320.098 480.38 320.196V321.373H479.947V320.281C479.948 320.267 479.946 320.253 479.94 320.239C479.934 320.226 479.926 320.214 479.915 320.204C479.904 320.194 479.891 320.187 479.876 320.181C479.862 320.176 479.846 320.174 479.83 320.175H478.99V321.373H478.558V319.827H479.971Z",
  fill: "#495870"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M481.013 321.881V321.537H481.983C481.998 321.538 482.013 321.535 482.028 321.53C482.042 321.525 482.055 321.517 482.066 321.507C482.077 321.497 482.085 321.485 482.091 321.472C482.096 321.459 482.099 321.445 482.098 321.431V321.372H481.118C481.009 321.372 480.906 321.333 480.829 321.264C480.752 321.194 480.709 321.1 480.709 321.002V320.199C480.71 320.101 480.753 320.007 480.829 319.938C480.906 319.869 481.01 319.83 481.118 319.83H482.53V321.513C482.53 321.611 482.486 321.705 482.41 321.774C482.334 321.843 482.231 321.883 482.123 321.884L481.013 321.881ZM482.098 321.023V320.175H481.258C481.242 320.174 481.227 320.176 481.212 320.181C481.198 320.186 481.185 320.194 481.173 320.204C481.163 320.214 481.154 320.226 481.148 320.239C481.143 320.253 481.14 320.267 481.141 320.281V320.919C481.141 320.933 481.143 320.947 481.149 320.96C481.154 320.973 481.163 320.985 481.174 320.994C481.185 321.004 481.198 321.012 481.213 321.017C481.227 321.022 481.242 321.024 481.258 321.023H482.098Z",
  fill: "#495870"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M485.356 320.429C485.464 320.43 485.567 320.469 485.644 320.539C485.72 320.608 485.763 320.702 485.763 320.8V321.002C485.763 321.1 485.72 321.194 485.644 321.263C485.567 321.333 485.464 321.372 485.356 321.373H484.008V321.029H485.219C485.234 321.029 485.249 321.026 485.263 321.021C485.277 321.016 485.29 321.008 485.301 320.999C485.312 320.989 485.32 320.977 485.326 320.964C485.332 320.952 485.335 320.938 485.335 320.924V320.875C485.335 320.847 485.323 320.82 485.301 320.8C485.279 320.78 485.25 320.769 485.219 320.769H484.392C484.338 320.769 484.285 320.76 484.236 320.741C484.186 320.723 484.141 320.696 484.103 320.661C484.065 320.627 484.036 320.586 484.015 320.541C483.995 320.496 483.984 320.448 483.984 320.4V320.196C483.985 320.099 484.028 320.005 484.104 319.936C484.18 319.866 484.284 319.827 484.392 319.827H485.666V320.17H484.529C484.514 320.169 484.498 320.171 484.484 320.177C484.469 320.182 484.456 320.189 484.445 320.199C484.434 320.209 484.426 320.221 484.42 320.234C484.414 320.247 484.412 320.261 484.413 320.275V320.321C484.412 320.335 484.414 320.349 484.42 320.362C484.425 320.376 484.434 320.388 484.445 320.398C484.456 320.408 484.469 320.416 484.483 320.422C484.498 320.427 484.514 320.43 484.529 320.429H485.356Z",
  fill: "#495870"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M486.501 321.373C486.393 321.372 486.29 321.333 486.214 321.263C486.137 321.194 486.094 321.1 486.094 321.002V319.827H486.526V320.919C486.526 320.933 486.528 320.947 486.534 320.96C486.54 320.973 486.548 320.984 486.559 320.994C486.57 321.004 486.583 321.011 486.597 321.017C486.611 321.022 486.626 321.024 486.642 321.023H487.483V319.827H487.916V321.51C487.914 321.608 487.87 321.701 487.794 321.771C487.717 321.84 487.615 321.879 487.507 321.881H486.401V321.537H487.366C487.382 321.538 487.398 321.536 487.412 321.531C487.427 321.526 487.44 321.518 487.451 321.508C487.462 321.498 487.47 321.486 487.476 321.473C487.481 321.46 487.484 321.445 487.483 321.431V321.373H486.501Z",
  fill: "#495870"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M489.622 320.429C489.73 320.43 489.834 320.469 489.911 320.538C489.987 320.608 490.03 320.702 490.031 320.8V321.002C490.03 321.1 489.987 321.194 489.911 321.264C489.834 321.333 489.73 321.372 489.622 321.373H488.274V321.029H489.485C489.5 321.029 489.515 321.027 489.529 321.021C489.544 321.016 489.557 321.009 489.568 320.999C489.578 320.989 489.587 320.978 489.593 320.965C489.599 320.952 489.601 320.938 489.601 320.924V320.875C489.601 320.861 489.599 320.847 489.593 320.834C489.587 320.821 489.578 320.81 489.568 320.8C489.557 320.79 489.544 320.782 489.529 320.777C489.515 320.772 489.5 320.769 489.485 320.769H488.653C488.6 320.769 488.547 320.76 488.497 320.742C488.447 320.723 488.402 320.696 488.364 320.662C488.326 320.627 488.296 320.587 488.275 320.542C488.255 320.497 488.244 320.448 488.245 320.4V320.196C488.245 320.098 488.288 320.004 488.365 319.935C488.442 319.866 488.545 319.827 488.653 319.827H489.926V320.17H488.791C488.775 320.169 488.76 320.171 488.745 320.176C488.731 320.181 488.718 320.189 488.706 320.199C488.695 320.209 488.687 320.221 488.681 320.234C488.676 320.247 488.673 320.261 488.674 320.275V320.321C488.673 320.335 488.676 320.349 488.681 320.362C488.687 320.376 488.695 320.388 488.706 320.398C488.717 320.408 488.731 320.416 488.745 320.422C488.76 320.427 488.775 320.43 488.791 320.429H489.622Z",
  fill: "#495870"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M491.965 320.175H491.303V321.372H490.871V320.175H490.211V319.827H490.871V319.478H491.303V319.827H491.965V320.175Z",
  fill: "#495870"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M492.146 320.196C492.146 320.148 492.156 320.1 492.177 320.055C492.197 320.01 492.227 319.969 492.265 319.935C492.303 319.901 492.348 319.873 492.398 319.855C492.447 319.836 492.5 319.827 492.554 319.827H493.574C493.682 319.827 493.786 319.866 493.862 319.935C493.939 320.004 493.982 320.098 493.983 320.196V320.4C493.983 320.448 493.972 320.497 493.952 320.542C493.931 320.587 493.901 320.627 493.863 320.662C493.825 320.696 493.78 320.723 493.73 320.742C493.681 320.76 493.628 320.769 493.574 320.769H492.577V320.919C492.577 320.933 492.579 320.947 492.585 320.96C492.591 320.973 492.599 320.985 492.61 320.994C492.621 321.004 492.634 321.012 492.649 321.017C492.663 321.022 492.679 321.024 492.694 321.023H493.907V321.367H492.554C492.446 321.367 492.342 321.328 492.266 321.258C492.189 321.189 492.146 321.095 492.146 320.997V320.196ZM492.694 320.17C492.678 320.169 492.663 320.171 492.649 320.177C492.634 320.182 492.621 320.189 492.61 320.199C492.599 320.209 492.591 320.221 492.585 320.234C492.579 320.247 492.577 320.261 492.577 320.275V320.437H493.434C493.449 320.438 493.465 320.436 493.479 320.431C493.494 320.426 493.507 320.418 493.518 320.408C493.529 320.398 493.537 320.386 493.543 320.373C493.549 320.36 493.551 320.346 493.55 320.332V320.275C493.551 320.261 493.549 320.247 493.543 320.234C493.537 320.221 493.529 320.209 493.518 320.199C493.507 320.189 493.494 320.181 493.479 320.176C493.465 320.171 493.449 320.169 493.434 320.17H492.694Z",
  fill: "#495870"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M496.539 319.827C496.647 319.828 496.751 319.868 496.827 319.936C496.904 320.005 496.949 320.098 496.951 320.196V321.373H496.519V320.281C496.519 320.267 496.516 320.253 496.51 320.24C496.504 320.227 496.496 320.215 496.485 320.206C496.474 320.196 496.461 320.188 496.447 320.183C496.433 320.177 496.417 320.175 496.402 320.175H495.841V321.373H495.409V320.175H494.744V321.373H494.312V319.827H496.539Z",
  fill: "#495870"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M449.651 311.854L447.21 312.96L444.768 311.854L447.21 310.747L449.651 311.854Z",
  fill: "#02EEFD"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M447.211 312.96C446.757 313.782 446.06 314.473 445.197 314.956C444.335 315.439 443.341 315.695 442.327 315.695C441.313 315.695 440.319 315.439 439.457 314.956C438.594 314.473 437.897 313.782 437.443 312.96L439.885 311.854C440.111 312.265 440.46 312.611 440.891 312.852C441.322 313.094 441.819 313.222 442.326 313.222C442.833 313.222 443.33 313.094 443.762 312.852C444.193 312.611 444.541 312.265 444.768 311.854L447.211 312.96Z",
  fill: "#08B5FB"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M439.883 311.854L437.442 312.96L435 311.854L437.442 310.747L439.883 311.854Z",
  fill: "#02EEFD"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M449.653 311.854C449.652 311.859 449.652 311.865 449.653 311.87C449.36 313.438 448.464 314.862 447.123 315.889C445.783 316.915 444.085 317.478 442.33 317.478C440.575 317.478 438.877 316.915 437.536 315.889C436.196 314.862 435.3 313.438 435.007 311.87C435.007 311.865 435.007 311.859 435.007 311.854L437.449 312.96C437.903 313.782 438.6 314.473 439.463 314.956C440.325 315.439 441.319 315.695 442.333 315.695C443.347 315.695 444.341 315.439 445.203 314.956C446.066 314.473 446.763 313.782 447.217 312.96L449.653 311.854Z",
  fill: "#3B82FF"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M447.21 305.214V309.641L444.768 308.534V304.108L447.21 305.214Z",
  fill: "#08B5FB"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M449.653 304.108L447.21 305.214L444.768 304.108L447.21 303.001L449.653 304.108Z",
  fill: "#02EEFD"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M449.653 304.108V308.534L447.21 309.641V305.214L449.653 304.108Z",
  fill: "#3B82FF"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M439.883 304.108L437.442 305.215L435 304.108L437.442 303.002L439.883 304.108Z",
  fill: "#02EEFD"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M437.442 305.214V309.641L435 308.534V304.108L437.442 305.214Z",
  fill: "#08B5FB"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M439.883 304.108V308.534L437.442 309.641V305.214L439.883 304.108Z",
  fill: "#3B82FF"
});

var _ref126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_0_1",
  x: 287.765,
  y: 605.395,
  width: 620.175,
  height: 106.995,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  result: "effect1_foregroundBlur_0_1"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_0_1",
  x: 318,
  y: 293,
  width: 561.606,
  height: 324.073,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0_1"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0_1",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_0_1",
  x: 618.084,
  y: 556.482,
  width: 463.628,
  height: 296.518,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0_1"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0_1",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_0_1",
  x1: 1328.11,
  y1: 6.03668,
  x2: 885.336,
  y2: 1106.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C5D3F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_0_1",
  x1: "-nan",
  y1: "-nan",
  x2: "-nan",
  y2: "-nan",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F24390"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE4B68",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_0_1",
  x1: 573.894,
  y1: 179.452,
  x2: 457.189,
  y2: 650.346,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3B82FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B82FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_0_1",
  x1: 620.277,
  y1: 179.452,
  x2: 736.983,
  y2: 650.346,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3B82FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B82FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_0_1",
  x1: 592.268,
  y1: 635.534,
  x2: 614.102,
  y2: 644.231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#199DEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EC7FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_0_1",
  x1: 671.575,
  y1: 718.991,
  x2: 711.845,
  y2: 718.991,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_0_1",
  x1: 189.234,
  y1: 725.635,
  x2: 229.503,
  y2: 725.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})));

function SvgCommunity1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 853,
    viewBox: "0 0 1152 853",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 525,
    y: 669,
    width: 145,
    height: 62
  }, _ref15), _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity1);
export default __webpack_public_path__ + "static/media/community1.b6cc455a.svg";
export { ForwardRef as ReactComponent };